export enum CourtEnum {
  // Stuttgart Courts
  StuttgartLg = "StuttgartLg",
  StuttgartAg = "StuttgartAg",
  StuttgartArbg = "ArbGStuttgart",
  StuttgartOlg = "OLGStuttgart",
  BwLarbg = "BwLarbg",
  BwFg = "BwFg",
  CommercialCourtBW = "CommercialCourtBW",

  // Heilbronn

  HeilbronnLg = "HeilbronnLg",

  // Landau Courts
  LandauLg = "LandauLg",
  LandauAg = "LandauAg",
  LudgwigshafenArbG = "LudwigshafenArbG",
  ZweibrueckenOlg = "ZweibrueckenOlg",
  RlpFg = "RlpFg",

  // Koblenz Courts
  KoblenzLG = "KoblenzLG",
  KoblenzAG = "KoblenzAG",
  KoblenzArbG = "KoblenzArbG",
  KoblenzOLG = "KoblenzOLG",
  RlpLag = "RlpLag",

  // Munich Courts
  MunichLGI = "MunichLGI",
  MunichLGII = "MunichLGII",
  BayObLG = "BayObLG",
  MunichAG = "MunichAG",
  MunichOLG = "MunichOLG",
  MunichArbG = "MunichArbG",
  MunichLag = "MunichLag",
  MunichFg = "MunichFg",

  // Kaiserslautern Courts
  KaiserslauternLg = "KaiserslauternLg",
  KaiserslauternAg = "KaiserslauternAg",
  KaiserslauternArbG = "KaiserslauternArbG",
}
